// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c6runZFTFJMxXHv4{margin-top:20px;font-size:1em}.c6runZFTFJMxXHv4 .dgfiCt3cunM7tAF2 .qy11YM8UMWYRGhNg{float:left;color:#f1634f}.c6runZFTFJMxXHv4 .dgfiCt3cunM7tAF2 .nQJdNWKiQMkvHoLu{color:#f1634f;font-weight:600}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `c6runZFTFJMxXHv4`,
	"printError": `dgfiCt3cunM7tAF2`,
	"icon": `qy11YM8UMWYRGhNg`,
	"value": `nQJdNWKiQMkvHoLu`
};
export default ___CSS_LOADER_EXPORT___;
